import styled from 'styled-components';
import { Paper, Typography, TextField, Button } from '@material-ui/core';
import { darken, rgba } from 'polished';

const THEME_COLOR = '#6b63d5';

export const LoginContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, ${rgba(THEME_COLOR, 0.1)} 0%, ${rgba(THEME_COLOR, 0.05)} 100%);
  padding: 20px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
`;

export const LoginCard = styled(Paper)`
  && {
    width: 100%;
    max-width: 420px;
    padding: 40px;
    border-radius: 12px;
    box-shadow: 0 8px 32px ${rgba(THEME_COLOR, 0.15)};
    background: white;
    border: 1px solid ${rgba(THEME_COLOR, 0.1)};
  }
`;

export const LogoSection = styled.div`
  text-align: center;
  margin-bottom: 32px;
`;

export const LogoIcon = styled.i`
  font-size: 48px;
  color: ${THEME_COLOR};
  margin-bottom: 16px;
  display: block;
`;

export const Title = styled(Typography)`
  && {
    font-size: 1.75rem;
    font-weight: 600;
    color: ${darken(0.2, THEME_COLOR)};
    margin-bottom: 8px;
  }
`;

export const Subtitle = styled(Typography)`
  && {
    font-size: 0.95rem;
    color: ${rgba('#000', 0.6)};
    margin-bottom: 8px;
  }
`;

export const NodeInfo = styled.div`
  background: ${rgba(THEME_COLOR, 0.05)};
  border: 1px solid ${rgba(THEME_COLOR, 0.1)};
  border-radius: 8px;
  padding: 16px;
  margin: 24px 0;
  text-align: center;
`;

export const NodeLabel = styled(Typography)`
  && {
    font-size: 0.8rem;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: ${rgba(THEME_COLOR, 0.7)};
    font-weight: 600;
    margin-bottom: 4px;
  }
`;

export const NodeAddress = styled(Typography)`
  && {
    font-size: 1.1rem;
    font-weight: 500;
    color: ${darken(0.1, THEME_COLOR)};
    word-break: break-all;
    
    &.network-url {
      font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
      font-size: 0.9rem;
      opacity: 0.8;
    }
  }
`;

export const FormSection = styled.div`
  margin-bottom: 32px;
`;

export const SectionTitle = styled(Typography)`
  && {
    font-size: 1.1rem;
    font-weight: 600;
    color: ${darken(0.2, THEME_COLOR)};
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;

export const SectionIcon = styled.i`
  font-size: 1.2rem;
  color: ${THEME_COLOR};
`;

export const StyledTextField = styled(TextField)`
  && {
    margin-bottom: 16px;
    
    .MuiOutlinedInput-root {
      border-radius: 8px;
      
      &:hover .MuiOutlinedInput-notchedOutline {
        border-color: ${THEME_COLOR};
      }
      
      &.Mui-focused .MuiOutlinedInput-notchedOutline {
        border-color: ${THEME_COLOR};
        border-width: 2px;
      }
    }
    
    .MuiInputLabel-root {
      &.Mui-focused {
        color: ${THEME_COLOR};
      }
    }
    
    .MuiOutlinedInput-input {
      padding: 14px;
      font-size: 1rem;
    }
  }
`;

export const LoginButton = styled(Button)`
  && {
    height: 48px;
    border-radius: 8px;
    font-size: 1rem;
    font-weight: 600;
    text-transform: none;
    background: ${THEME_COLOR};
    color: white;
    margin-bottom: 16px;
    
    &:hover {
      background: ${darken(0.1, THEME_COLOR)};
    }
    
    &:disabled {
      background: ${rgba(THEME_COLOR, 0.4)};
      color: ${rgba('#fff', 0.7)};
    }
    
    .MuiButton-startIcon {
      margin-right: 8px;
      
      i {
        font-size: 1.2rem;
      }
    }
  }
`;

export const SecondaryButton = styled(Button)`
  && {
    height: 42px;
    border-radius: 8px;
    font-size: 0.9rem;
    font-weight: 500;
    text-transform: none;
    color: ${THEME_COLOR};
    border-color: ${rgba(THEME_COLOR, 0.3)};
    
    &:hover {
      background: ${rgba(THEME_COLOR, 0.05)};
      border-color: ${THEME_COLOR};
    }
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 24px;
`;

export const SecurityNote = styled.div`
  background: ${rgba('#4caf50', 0.05)};
  border: 1px solid ${rgba('#4caf50', 0.2)};
  border-radius: 6px;
  padding: 12px;
  margin-top: 16px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

export const SecurityIcon = styled.i`
  font-size: 1rem;
  color: #4caf50;
  margin-top: 2px;
`;

export const SecurityText = styled(Typography)`
  && {
    font-size: 0.8rem;
    color: ${rgba('#000', 0.7)};
    line-height: 1.4;
  }
`;
